import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getOptions } from "../../modules/restaurant/services/payment-method.services";

export const fetchPaymentMethods = createAsyncThunk(
    "paymentMethods/fetch",
    async () => {
        const res = await getOptions();
        return res.data;
    }
);

const paymentMethodsSlice = createSlice({
    name: "paymentMethods",
    initialState: {
        data: [],
        status: "idle",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPaymentMethods.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(fetchPaymentMethods.rejected, (state) => {
                state.status = "failed";
            });
    },
});

export default paymentMethodsSlice.reducer;